import React, { useState, useEffect } from "react";
import axiosClient from "../../../utils/axiosClient";
import {
  urlHorariosAtendimentoEmpresas,
  urlHorariosDisponiveisAgendamentoEmpresas,
  urlServicosAgendamentoEmpresas,
  urlClientesAgendamento,
  urlAdicionar,
} from "../../../utils/constants";
import MenuSide from "../../../components/empresas/MenuSide";
import {
  IonCard,
  IonItem,
  IonLabel,
  IonContent,
  IonDatetime,
  IonPage,
  IonToast,
  IonButton,
  IonTextarea,
  IonModal,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonSearchbar,
  IonBadge,
  IonAlert,
} from "@ionic/react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import HeaderApp from "../../../components/global/HeaderItem";
import ModalServicos from "./ModalServicos";

const consultaHorariosAtendimento = async (dataAgendamento) => {
  try {
    const response = await axiosClient.post(urlHorariosAtendimentoEmpresas, {
      data_agendamento: dataAgendamento,
    });
    return response.data;
  } catch (error) {
    return [];
  }
};

const consultaHorariosDisponiveis = async (dataAgendamento) => {
  try {
    const response = await axiosClient.post(
      urlHorariosDisponiveisAgendamentoEmpresas,
      {
        data_selecionada: dataAgendamento,
      }
    );
    return response.data;
  } catch (error) {
    return [];
  }
};

const consultaServicos = async () => {
  try {
    const response = await axiosClient.post(urlServicosAgendamentoEmpresas, {});
    return response.data;
  } catch (error) {
    return [];
  }
};

const consultaClientes = async () => {
  try {
    const response = await axiosClient.post(urlClientesAgendamento, {});
    return response.data;
  } catch (error) {
    return [];
  }
};

const getDayOfWeek = (dateString) => {
  const days = [
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado",
    "Domingo",
  ];
  const date = new Date(dateString);
  const dayIndex = date.getDay();
  return days[dayIndex];
};

const getDatesOfMonth = (year, month) => {
  const startDate = new Date(year, month - 1, 1);
  const endDate = new Date(year, month, 0);
  const datesArray = [];

  for (
    let date = startDate;
    date <= endDate;
    date.setDate(date.getDate() + 1)
  ) {
    const currentDate = new Date(date);
    if (currentDate.getMonth() === month - 1) {
      const data = currentDate.toISOString().split("T")[0];
      const dia = currentDate.getDate();
      const mes = currentDate.getMonth() + 1;
      const ano = currentDate.getFullYear();

      datesArray.push({ data, dia, mes, ano });
    }
  }

  return datesArray;
};

function groupDatesByWeekday(dates) {
  const weekdays = ["DOM.", "SEG.", "TER.", "QUA.", "QUI.", "SEX.", "SÁB."];
  const groupedDates = {
    "DOM.": [],
    "SEG.": [],
    "TER.": [],
    "QUA.": [],
    "QUI.": [],
    "SEX.": [],
    "SÁB.": [],
  };

  dates.forEach((date) => {
    const weekdayIndex = new Date(date.data).getDay();
    const weekday = weekdays[weekdayIndex];
    groupedDates[weekday].push(date);
  });

  return groupedDates;
}

const categorizeHorario = (horario) => {
  const [hour] = horario.split(":").map(Number);

  if (hour >= 5 && hour < 12) {
    return {
      categoria: "Manhã",
      icon: <i className="ri-sun-foggy-fill" style={{ color: " #FDEC75" }}></i>,
    };
  } else if (hour >= 13 && hour < 18) {
    return {
      categoria: "Tarde",
      icon: <i className="ri-sun-fill" style={{ color: "#FF8800" }}></i>,
    };
  } else {
    return {
      categoria: "Noite",
      icon: <i className="ri-moon-fill" style={{ color: "#153C4B" }}></i>,
    };
  }
};

export default function AgendarUsuario() {
  const dataAtual = moment().format("YYYY-MM-DD");

  const [modalServicos, setModalServicos] = useState(false);
  const [nomeServico, setNomeServico] = useState("");

  const [dataAgendamento, setDataAgendamento] = useState(dataAtual);
  const [horaAgendamento, setHoraAgendamento] = useState("");
  const [obsAgendamento, setObsAgendamento] = useState("");
  const [servicoAgendamento, setServicoAgendamento] = useState("");
  const [clienteAgendamento, setCLienteAgendamento] = useState("");
  const [filtroCliente, setFiltroCliente] = useState("");

  const [corMensagemDiaSelecionado, setCorMensagemDiaSelecionado] =
    useState("secondary-light");
  const [mensagemDiaSelecionado, setMensagemDiaSelecionado] = useState("");
  const [horariosDisponiveis, setHorariosDisponiveis] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [modalClientes, setModalClientes] = useState(false);
  const navigate = useNavigate();

  const [mesAtual, setMesAtual] = useState(moment().format("MM"));
  const [anoAtual, setAnoAtual] = useState(moment().format("YYYY"));
  const [dias, setDias] = useState(getDatesOfMonth(anoAtual, mesAtual));
  const [diasSemana, setDiasSemana] = useState(groupDatesByWeekday(dias));

  const [colorToast, setColorToast] = useState("");
  const [iconToast, setIconToast] = useState("");
  const [mensagemToast, setMensagemToast] = useState("");
  const [tempoToast, setTempoToast] = useState("");
  const [textoToast, setTextoToast] = useState("");
  const [statusToast, setStatusToast] = useState(false);

  const [statusAlert1, setAlert1] = useState(false);
  const [statusAlert2, setAlert2] = useState(false);

  useEffect(() => {
    setMesAtual(moment().format("MM"));
    setAnoAtual(moment().format("YYYY"));
    setDias(getDatesOfMonth(anoAtual, mesAtual));
    setDiasSemana(groupDatesByWeekday(dias));
  }, []);

  const agendarHorario = () => {
    axiosClient
      .post(urlAdicionar("empresas", "agendar"), {
        data_agendamento: moment(dataAgendamento).format("YYYY-MM-DD"),
        hora_agendamento: horaAgendamento,
        servico_id: Number(servicoAgendamento),
        obs: obsAgendamento,
        cliente_id: Number(clienteAgendamento.id),
      })
      .then(async (response) => {
        if (response.data.status == "agendamento_efetuado") {
          const irParaAgendmamentos = () => {
            navigate({ pathname: "/empresas/agendamentos" });
          };

          setColorToast("success");
          setIconToast("alert-outline");
          setMensagemToast("Agendamento efetuado com sucesso.");
          setTempoToast(60000);
          setTextoToast("Ok");
          setStatusToast(true);

          setTimeout(() => {
            irParaAgendmamentos();
          }, 3000);
        } else if (response.data.status == "horario_indisponivel") {
          setColorToast("danger");
          setIconToast("alert-outline");
          setMensagemToast("Ops, alguém acabou de agendar nesse horário.");
          setTempoToast(60000);
          setTextoToast("Ok");
          setStatusToast(true);
        } else if (response.data.status == "campo_vazio") {
          setColorToast("warning");
          setIconToast("alert-outline");
          setMensagemToast(
            "Ops, o campo " + response.data.campo + " precisa ser preenchido!"
          );
          setTempoToast(60000);
          setTextoToast("Ok");
          setStatusToast(true);
        } else if (response.data.status == "nao_logado") {
          setAlert1(true);
        } else if (response.data.status == "empresa_nao_selecionada") {
          setColorToast("danger");
          setIconToast("alert-outline");
          setMensagemToast("Nenhuma empresa selecionada");
          setTempoToast(60000);
          setTextoToast("Ok");
          setStatusToast(true);
        } else if (response.data.status == "nao_atendemos_nesse_dia") {
          setColorToast("danger");
          setIconToast("alert-outline");
          setMensagemToast("Ops, nś não atendemos no dia selecionado.");
          setTempoToast(60000);
          setTextoToast("Ok");
          setStatusToast(true);
        } else if (response.data.status == "fora_horario") {
          setColorToast("danger");
          setIconToast("alert-outline");
          setMensagemToast("Ops, nós não atendemos no horário selecionado.");
          setTempoToast(60000);
          setTextoToast("Ok");
          setStatusToast(true);
        } else if (response.data.status == "limite_atingido") {
          setAlert2(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const verificarServicos = async () => {
      const resultado = await consultaServicos();
      const resultadoClientes = await consultaClientes();
      setServicos(resultado);
      setClientes(resultadoClientes);
    };
    verificarServicos();
  }, [diasSemana]);

  useEffect(() => {
    const verificarHorarios = async () => {
      const resultadoHorario = await consultaHorariosAtendimento(
        dataAgendamento
      );
      setMensagemDiaSelecionado(resultadoHorario.mensagem);
      if (resultadoHorario.status === "disponivel") {
        setCorMensagemDiaSelecionado("success");
      } else {
        setCorMensagemDiaSelecionado("danger");
      }
    };
    verificarHorarios();

    const verificarHorariosDisponiveis = async () => {
      const resultadoHorario = await consultaHorariosDisponiveis(
        dataAgendamento
      );
      setHorariosDisponiveis(resultadoHorario);
    };
    verificarHorariosDisponiveis();
  }, [dataAgendamento]);

  const clientesFiltrados = clientes.filter((cliente) =>
    cliente.nome.toLowerCase().includes(filtroCliente.toLowerCase())
  );

  const servicoSelecionado = (servico) => {
    if (servico) {
      setServicoAgendamento(servico.id);
      setNomeServico(servico.nome);
    }
  };

  const horariosPorCategoria = horariosDisponiveis.reduce((acc, horario) => {
    const { categoria, icon } = categorizeHorario(horario);
    if (!acc[categoria]) acc[categoria] = { horarios: [], icon };
    acc[categoria].horarios.push(horario);
    return acc;
  }, {});

  return (
    <IonPage  id="main-content">
      <IonContent>
        <HeaderApp />

        <div className="ion-margin">
          {clienteAgendamento !== "" ? (
            <IonLabel>Alterar cliente</IonLabel>
          ) : (
            <IonLabel>Escolha um cliente</IonLabel>
          )}
          {clienteAgendamento !== "" ? (
            <IonItem onclick={() => setModalClientes(true)} button={true}>
              <IonLabel>{clienteAgendamento.nome} - Alterar cliente</IonLabel>
            </IonItem>
          ) : (
            <IonItem onclick={() => setModalClientes(true)} button={true}>
              <IonLabel>Clique aqui</IonLabel>
            </IonItem>
          )}
          <IonLabel position="stacked">Escolha uma data</IonLabel>
          <IonDatetime
            style={{ position: "relative" }}
            value={dataAgendamento}
            min={dataAtual}
            onIonChange={(e) => {
              e.preventDefault();
              setDataAgendamento(e.detail.value);
            }}
            presentation="date"
            mode="md"
          ></IonDatetime>
          <IonCard color={corMensagemDiaSelecionado}>
            <div style={{ margin: 12 }}>
              {getDayOfWeek(dataAgendamento)} : {mensagemDiaSelecionado}
            </div>
          </IonCard>

          <IonItem button onClick={() => setModalServicos(true)}>
            <IonLabel>
              {nomeServico ? (
                <>
                  <IonBadge color="secondary-light" slot="end">
                    {nomeServico}
                  </IonBadge>
                  <h4>Clique para alterar o serviço</h4>
                </>
              ) : (
                <>
                  <h4>
                    <IonBadge color="secondary-light" slot="end">
                      Selecione um serviço
                    </IonBadge>
                  </h4>
                </>
              )}
            </IonLabel>
          </IonItem>

          <ModalServicos
            modalServicos={modalServicos}
            setModalServicos={setModalServicos}
            onServicoSelecionado={servicoSelecionado}
          />

          {servicoAgendamento !== "" ? (
            <div>
              <div className="ion-text-center" style={{ marginTop: "7px" }}>
                <IonLabel position="stacked">Defina o horário</IonLabel>
              </div>
              <div className="ion-margin-horizontal">
                {Object.entries(horariosPorCategoria).map(
                  ([categoria, { horarios, icon }]) => (
                    <div key={categoria}>
                      <h3>
                        {icon} {categoria}
                      </h3>
                      <div className="row">
                        {horarios.map((horario, index) => (
                          <div
                            className="col-4"
                            key={index}
                            style={{ marginBottom: "5px" }}
                          >
                            <div
                              key={index}
                              onClick={() => setHoraAgendamento(horario)}
                              style={{
                                padding: "10px 20px",
                                borderRadius: "12px",
                                textAlign: "center",
                                cursor: "pointer",
                                fontSize: "13px",
                                border:
                                  horaAgendamento === horario
                                    ? "solid 2px #141458"
                                    : "2px solid #ccc",
                                color:
                                  horaAgendamento === horario
                                    ? "#004085"
                                    : "#333",

                                boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                                transition: "0.3s",
                              }}
                            >
                              {horaAgendamento === horario && (
                                <i
                                  className="ri-check-line"
                                  style={{ marginRight: "5px" }}
                                ></i>
                              )}
                              {horario}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          ) : (
            <span></span>
          )}
          <br />
          <IonLabel position="stacked">Alguma observação?</IonLabel>
          <IonItem>
            <IonTextarea
              className="obs"
              placeholder="Informe sua observação"
              onIonChange={(e) => setObsAgendamento(e.detail.value)}
              value={obsAgendamento}
            ></IonTextarea>
          </IonItem>
          <br />
          <IonButton
            expand="full"
            color="secondary-light"
            onClick={agendarHorario}
          >
            Agendar &nbsp; <i className="ri-calendar-line icone19px"></i>
          </IonButton>
          <br />
        </div>

        <IonToast
          isOpen={statusToast}
          color={colorToast}
          icon={iconToast}
          message={mensagemToast}
          onDidDismiss={() => setStatusToast(false)}
          duration={tempoToast}
          buttons={[
            {
              text: textoToast,
              role: "info",
              handler: () => {
                return;
              },
            },
          ]}
        ></IonToast>

        <IonAlert
          isOpen={statusAlert1}
          header="Atenção"
          message="Você precisa estar logado na sua conta para fazer um agendamento!"
          buttons={[
            {
              text: "Entrar",
              role: "cancel",
              handler: () => {
                navigate({ pathname: "/entrar" });
              },
            },
          ]}
          onDidDismiss={() => setAlert1(false)}
        ></IonAlert>

        <IonAlert
          isOpen={statusAlert2}
          header="Atenção"
          message="Seu limite de agendamentos mensais do plano grátis foi atingido, contrate o plano profissional para utilizar sem limitações!"
          buttons={[
            {
              text: "Contratar",
              role: "confirm",
              handler: () => {
                navigate({ pathname: "/empresas/inicio" });
              },
            },
          ]}
          onDidDismiss={() => setAlert2(false)}
        ></IonAlert>
      </IonContent>

      {modalClientes ? (
        <div>
          <IonModal isOpen={true} mode="ios" backdropDismiss="false">
            <IonHeader>
              <IonToolbar>
                <IonButtons slot="start">
                  <IonButton
                    onclick={() => {
                      setModalClientes(false);
                      setFiltroCliente("");
                    }}
                  >
                    Fechar
                  </IonButton>
                </IonButtons>
                <IonTitle>Clientes</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
            <IonSearchbar
  autocomplete="on"
  value={filtroCliente}
  onIonInput={(e) => setFiltroCliente(e.detail.value.toLowerCase())} // Atualiza o estado em tempo real
  debounce={0} // Remove qualquer atraso na atualização do estado
  inputmode="text"
  placeholder="Buscar clientes"
></IonSearchbar>

{clientes
  .filter((cliente) =>
    cliente.nome.toLowerCase().includes(filtroCliente)
  )
  .map((cliente, index) => (
    <IonItem
      key={index}
      onClick={() => {
        setCLienteAgendamento(cliente);
        setModalClientes(false);
        setFiltroCliente("");
      }}
      button={true}
    >
      <IonLabel>{cliente.nome}</IonLabel>
    </IonItem>
))}

            </IonContent>
          </IonModal>
        </div>
      ) : (
        <span></span>
      )}

      <MenuSide />
    </IonPage>
  );
}
